"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var prop_types_1 = __importDefault(require("prop-types"));
function ColorOption(props) {
    var big = props.big, _a = props.color, name = _a.name, sourceHex = _a.hex;
    var hex = sourceHex &&
        sourceHex
            .split(';')
            .map(function (color) { return "#" + color; })
            .join(',');
    var style = hex && { background: "linear-gradient( -45deg, " + hex + ")" };
    return (react_1.default.createElement("div", { className: classnames_1.default('aui-ColorOption', {
            'aui-ColorOption-big': big,
        }) },
        hex && react_1.default.createElement("span", { style: style }),
        name));
}
exports.default = ColorOption;
ColorOption.displayName = 'ColorOption';
ColorOption.propTypes = {
    big: prop_types_1.default.bool,
    color: prop_types_1.default.shape({
        name: prop_types_1.default.string,
        hex: prop_types_1.default.string,
    }),
};
ColorOption.defaultProps = {
    big: false,
    color: {},
};
